import { FormField } from '../form'

export const BCContractForm = (_) => {
  return <FormField name="remarks" inputProps={{ as: 'textarea', rows: 5, maxLength: 512 }} />
}
